<!-- warehouse-scanner.component.html -->
<app-scanner (scanSuccess)="handleScanSuccess($event)"></app-scanner>
